var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#651F70",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.667 4.667-.578 8.094A1.333 1.333 0 0 1 10.759 14H5.24a1.334 1.334 0 0 1-1.33-1.239l-.578-8.094m3.334 2.666v4m2.666-4v4M10 4.667v-2A.667.667 0 0 0 9.333 2H6.667A.667.667 0 0 0 6 2.667v2m-3.333 0h10.666"
  })));
};
export default SvgTrash;